<template>
  <div>
    <base-header class="pb-6 pt-5" type="gradient-success">

      <div class="mt-5">
        <div class="row">
          <div class="col">
            <h2 class="header-text">{{ this.project.title }}</h2>
            <p class="header-text"><b>{{ this.project.date }}</b></p>
            <p class="header-text desc">{{ this.project.desc }}</p>
          </div>
          <div class="col">
            <div class="text-right">
              <base-button @click="modal = true" icon="ni ni-settings" type="default"></base-button>
            </div>
          </div>
        </div>
      </div>

    </base-header>

    <modal :show.sync="modal"
           body-classes="p-0"
           modal-classes="modal-dialog-centered modal-sm">
      <card body-classes="px-lg-5 py-lg-5" class="border-0"
            header-classes="bg-white pb-5"
            shadow
            type="secondary">
        <template>
          <div class="text-center text-muted mb-4">
            <small>{{ this.project.title }} - bearbeiten</small>
          </div>
          <form role="form">
            <base-input class="mb-3" placeholder="Name" type="text"
                        v-model="editProject.title"></base-input>

            <textarea class="form-control mb-3" placeholder="Beschreibung" rows="3"
                      style="resize: none;" v-model="editProject.desc"></textarea>

            <base-input addon-left-icon="ni ni-calendar-grid-58">
              <flat-picker :config="datePicker.config"
                           @on-close="blur"
                           @on-open="focus"
                           class="form-control datepicker"
                           slot-scope="{focus, blur}" v-model="datePicker.date">
              </flat-picker>
            </base-input>

            <div class="text-center">
              <base-button @click="updateProject" block class="my-4" type="primary">Speichern</base-button>
            </div>
          </form>
        </template>
      </card>
    </modal>

    <!-- Card Stats -->
    <div class="container">
      <div class="mt-5 mb-3">
        <div class="row">
          <div class="col-12 col-md-6">
            <stats-card :sub-title="this.getHours()"
                        class="mb-4 mb-xl-0"
                        icon="ni ni-chart-pie-35"
                        title="Stunden"
                        type="gradient-orange">
            </stats-card>
          </div>
          <div class="col-12 col-md-6">
            <stats-card :sub-title="this.getSales()"
                        class="mb-4 mb-xl-0"
                        icon="ni ni-money-coins"
                        title="Umsatz"
                        type="gradient-green">
            </stats-card>
          </div>
        </div>

      </div>

      <!-- Hours Controls -->
      <div class="mb-5">

        <div class="row">
          <div class="col">
            <base-button @click="this.addHour" block icon="ni ni-fat-add">1 Std.</base-button>
          </div>
          <div class="col">
            <base-button @click="this.addHalfHour" block icon="ni ni-fat-add">30 Min.</base-button>
          </div>
          <div class="col">
            <base-button @click="this.removeHour" block icon="ni ni-fat-delete" type="danger">30 Min.
            </base-button>
          </div>
        </div>

      </div>

      <!-- Timer Card -->
      <div class="row">
        <div class="col">
          <stats-card :sub-title="this.clock.time"
                      class="mb-4 mb-xl-0"
                      icon="ni ni-time-alarm"
                      title="Timer"
                      type="gradient-info">
          </stats-card>
        </div>
      </div>

      <!-- Timer Controls -->
      <div class="mt-3 mb-5">

        <div class="row">
          <div class="col">
            <div v-if="!this.clock.running">
              <base-button @click="this.start" block icon="ni ni-button-play">Start</base-button>
            </div>
            <div v-else>
              <base-button @click="this.stop" block icon="ni ni-button-pause">Pause</base-button>
            </div>
          </div>
          <div class="col">
            <base-button @click="this.save" block icon="ni ni-cloud-upload-96">Speichern</base-button>
          </div>
          <div class="col">
            <base-button @click="this.reset" block icon="ni ni-fat-remove" type="danger">Reset</base-button>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import firebase from 'firebase';
  import 'firebase/firestore';

  import flatPicker from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  import { German } from 'flatpickr/dist/l10n/de.js';

  export default {
    name: "Project",
    components: {
      flatPicker
    },
    data() {
      return {
        datePicker: {
          date: '01.01.2001',
          config: {
            allowInput: true,
            dateFormat: 'd.m.Y',
            locale: German
          }
        },
        editProject: {
          title: String,
          desc: String,
        },
        project: {},
        clock: {
          time: '00:00:00',
          timeBegan: null,
          timeStopped: null,
          stoppedDuration: 0,
          started: null,
          running: false
        },
        modal: false
      }
    },
    methods: {
      getHours() {
        return this.project.hours + ' std.'
      },
      getSales() {
        return new Intl.NumberFormat('de-DE', {
          style: 'currency',
          currency: 'EUR'
        }).format(this.project.hours * this.project.hourly_rate)
      },

      addHour() {
        const projectRef = firebase.firestore().collection("projects").doc(this.project.id);

        return projectRef.update({
          hours: this.project.hours + 1
        })
          .then(function () {
          })
          .catch(function (error) {
            // The document probably doesn't exist.
            // eslint-disable-next-line no-console
            console.error("Error updating document: ", error);
          });
      },
      addHalfHour() {
        const projectRef = firebase.firestore().collection("projects").doc(this.project.id);

        return projectRef.update({
          hours: this.project.hours + 0.5
        })
          .then(function () {
          })
          .catch(function (error) {
            // The document probably doesn't exist.
            // eslint-disable-next-line no-console
            console.error("Error updating document: ", error);
          });
      },
      removeHour() {
        const projectRef = firebase.firestore().collection("projects").doc(this.project.id);

        return projectRef.update({
          hours: this.project.hours - 0.5
        })
          .then(function () {
          })
          .catch(function (error) {
            // The document probably doesn't exist.
            // eslint-disable-next-line no-console
            console.error("Error updating document: ", error);
          });
      },

      start() {
        if (this.clock.running) return;

        if (this.clock.timeBegan === null) {
          this.reset();
          this.clock.timeBegan = new Date();
        }

        if (this.clock.timeStopped !== null) {
          this.clock.stoppedDuration += (new Date() - this.clock.timeStopped);
        }

        this.clock.started = setInterval(this.clockRunning, 10);
        this.clock.running = true;
      },
      stop() {
        this.clock.running = false;
        this.clock.timeStopped = new Date();
        clearInterval(this.clock.started);
      },
      reset() {
        this.clock.running = false;
        clearInterval(this.clock.started);
        this.clock.stoppedDuration = 0;
        this.clock.timeBegan = null;
        this.clock.timeStopped = null;
        this.clock.time = "00:00:00";
      },
      save() {
        let value = this.clock.time;
        if (value) {
          const parts = value.split(":");
          let secounds = +parts[2];
          let minutes = +parts[1];
          let hours = +parts[0];

          let mins = (secounds / 60) + minutes + (hours * 60);

          let roundedMinutes = Math.ceil(mins / 30) * 30;
          let timerHours = roundedMinutes / 60;

          const projectRef = firebase.firestore().collection("projects").doc(this.project.id);

          return projectRef.update({
            hours: this.project.hours + timerHours
          })
            .then(function () {
            })
            .catch(function (error) {
              // The document probably doesn't exist.
              // eslint-disable-next-line no-console
              console.error("Error updating document: ", error);
            });
        }
      },
      clockRunning() {
        const currentTime = new Date()
          , timeElapsed = new Date(currentTime - this.clock.timeBegan - this.clock.stoppedDuration)
          , hour = timeElapsed.getUTCHours()
          , min = timeElapsed.getUTCMinutes()
          , sec = timeElapsed.getUTCSeconds();

        this.clock.time =
          this.zeroPrefix(hour, 2) + ":" +
          this.zeroPrefix(min, 2) + ":" +
          this.zeroPrefix(sec, 2)
      },
      zeroPrefix(num, digit) {
        let zero = '';
        for (let i = 0; i < digit; i++) {
          zero += '0';
        }
        return (zero + num).slice(-digit);
      },
      updateProject() {
        const projectRef = firebase.firestore().collection("projects").doc(this.project.id);

        return projectRef.update({
          title: this.editProject.title,
          desc: this.editProject.desc,
          date: this.datePicker.date
        })
          .then(() => {
            this.modal = false
          })
          .catch(function (error) {
            // The document probably doesn't exist.
            // eslint-disable-next-line no-console
            console.error("Error updating document: ", error);
          });
      }
    },
    created() {
      let id = this.$route.query.projectId;

      firebase.firestore().collection("projects").doc(id).onSnapshot((doc) => {
        this.project = doc.data();
        this.project.id = doc.id;

        this.editProject.title = doc.data().title;
        this.editProject.desc = doc.data().desc;

        this.datePicker.date = doc.data().date
      });
    }
  }
</script>

<style scoped>
  .header-text {
    margin: 0;
    color: #FFFFFF;
    text-transform: uppercase;
  }

  .header-text.desc {
    text-transform: inherit;
  }
</style>